import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {ActionLogService} from '../../services/actionLogService/action-log.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {OverlayService} from "@src/app/services/overlay/overlay.service";
declare var Yiit;
@Component({
  selector: 'app-undo',
  templateUrl: './undo.component.html',
  styleUrls: ['./undo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UndoComponent implements OnDestroy, AfterViewInit {

  public Yiit = Yiit;
  public isDisabled: boolean;
  private destroy$ = new BehaviorSubject(false);
  private disabledCheck$ = new Subject();

  constructor(private actionLogger: ActionLogService, private cdr: ChangeDetectorRef, private overlayService: OverlayService) {
    this.initKeyListeners();
    this.initListeners();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.disabledCheck$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
      setTimeout(() => {
        this.cdr.markForCheck();
      });
    });
  }

  initListeners(): void {
    this.actionLogger.onConfigUpdated.subscribe((config) => {
      this.cdr.detectChanges();
    });
  }

  public isVisible(): boolean {
    return this.actionLogger.getLogsCount() > 0;
  }


  public undoAction() {
    this.overlayService.sendOverlayUndo();
    if (!this.isVisible()) {
      return;
    }
    this.actionLogger.undoAction();
  }

  private initKeyListeners() {
    const self = this;
    document.addEventListener('keydown', function (event) {
      if (event.ctrlKey && event.key === 'z') {
        self.undoAction();
      }
    });
  }

  disabled(): boolean {
    const condition = this.isDisabled || !this.isVisible();
    this.disabledCheck$.next(condition);
    return condition;
  }
}
